import * as actionTypes from '../actionTypes/orderTypes';

const initialState = {
    ordersList: [],
    ordersTotal: 0,
    ordersLoading: false,
    firstOrdersLoading: true,
    error: {},
}

const orders = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ORDER_START:
            return {
                ...state,
                ordersTotal: 0,
                ordersLoading: true,
            };
        case actionTypes.GET_ORDER_SUCCESS:
            return {
                ...state,
                ordersList: [...action.payload.list],
                ordersTotal: action.payload.total,
                ordersLoading: false,
                firstOrdersLoading: false,
            };
        case actionTypes.GET_ORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                ordersTotal: 0,
                ordersLoading: false,
            };
        case actionTypes.APPROVE_ORDER: {
            const currentState = state;

            const orderIndex = currentState.ordersList.findIndex(
                (order) => order.id === action.payload
            );

            currentState.ordersList[orderIndex].paymentStatus = 1;

            return { ...currentState };
        }
        case actionTypes.EDIT_ORDER: {
            const currentState = state;

            const orderIndex = currentState.ordersList.findIndex(
                (order) => order.id === action.payload.id
            );

            currentState.ordersList[orderIndex] = action.payload;

            return { ...currentState };
        }
        case actionTypes.CLEAR_ORDERS:
            return { ...initialState };
        default:
            return state;
    }
}

export default orders;